import useOnClickOutside from 'common/hooks/useOnClickOutside';
import React, { useRef } from 'react';

interface IProps {
  onViewClick: () => void;
  onEditClick: () => void;
  onAssignClick?: () => void;
  onRemoveClick: () => void;
  onDismiss: React.Dispatch<React.SetStateAction<number>>;
}

const TableActionWidget: React.FC<IProps> = ({
  onViewClick,
  onEditClick,
  onAssignClick,
  onRemoveClick,
  onDismiss
}) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const resetAndDismissDropdown = () => {
    dismiss();
  };

  useOnClickOutside(rootRef, resetAndDismissDropdown);

  const dismiss = () => {
    onDismiss(-1);
  };

  return (
    <div className="relative z-50">
      <div
        className="absolute right-0 top-[10px] w-[8rem] rounded-md bg-white text-[#35353580] shadow-xl shadow-slate-400"
        ref={rootRef}
      >
        <div className="flex flex-col py-3">
          <button
            type="button"
            onClick={onViewClick}
            className={`flex cursor-pointer items-center  border-b border-[#D9D9D9] p-2 py-1`}
          >
            <p className="ml-1 text-sm font-medium">View</p>
          </button>
          <button
            type="button"
            onClick={onEditClick}
            className={`flex cursor-pointer items-center  border-b border-[#D9D9D9] p-2 py-1`}
          >
            <p className="ml-1 text-sm font-medium">Edit</p>
          </button>
          {onAssignClick && (
            <button
              type="button"
              onClick={onAssignClick}
              className={`flex cursor-pointer items-center  border-b border-[#D9D9D9] p-2 py-1`}
            >
              <p className="ml-1 text-sm font-medium">Assign</p>
            </button>
          )}

          <button
            type="button"
            className={`flex cursor-pointer items-center p-2 py-1`}
            onClick={onRemoveClick}
          >
            <p className="ml-1 text-sm font-medium">Remove</p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TableActionWidget;
